import { useSetRecoilState } from 'recoil';

import {
  updateCustomerAssetDetailsFilterSelected,
  updateCustomerAssetDetailsFilters,
  updateCustomerAssetDetailsFiltersLoading,
} from './selector';
import { AssetsFilterProps } from './types';

export const useCustomerAssetsDetailsActions = (marketType: string | number) => {
  const marketTypeNormalized = String(marketType);

  const setAssetsDetailFilters = useSetRecoilState(
    updateCustomerAssetDetailsFilters({ productType: marketTypeNormalized })
  );
  const setAssetsDetailFiltersLoading = useSetRecoilState(
    updateCustomerAssetDetailsFiltersLoading({ productType: marketTypeNormalized })
  );
  const setAssetsDetailFiltersSelected = useSetRecoilState(
    updateCustomerAssetDetailsFilterSelected({ productType: marketTypeNormalized })
  );

  const handleUpdateCustomerAssetsDetailsFilters = (newFilters: AssetsFilterProps[]) => {
    setAssetsDetailFilters(newFilters);
  };

  const handleUpdateCustomerAssetsDetailsFiltersLoading = (isLoading: boolean) => {
    setAssetsDetailFiltersLoading(isLoading);
  };

  const handleUpdateCustomerAssetsDetailsFiltersSelected = (selectedIndex: number) => {
    setAssetsDetailFiltersSelected(selectedIndex);
  };

  return {
    handleUpdateCustomerAssetsDetailsFilters,
    handleUpdateCustomerAssetsDetailsFiltersLoading,
    handleUpdateCustomerAssetsDetailsFiltersSelected,
  };
};
